import { render } from "./HelpSchemajson.vue?vue&type=template&id=64420566"
import script from "./HelpSchemajson.vue?vue&type=script&lang=js"
export * from "./HelpSchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__